module.exports = __webpack_public_path__ + "img/right-arrow.185c33ae.svg";